import { mapState } from "vuex";
export const settingIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
    settingTopBarList() {
      // let isMaster = localStorage.userType == 101;
      let isMaster = this.shopInfo.isMaster;
      let topbarList = [
        {
          name: "店铺设置",
          isActive: false,
          path: "/setting",
          childrenPath: ["/setting/certification"],
          icon:require("@/assets/img/menuIcons/icon-setting.png")
        },
        {
          name: "小票设置",
          isActive: false,
          path: "/setting/print/normal",
          childrenPath: ["/setting/print/split", "/setting/print/template"],
          icon:require("@/assets/img/menuIcons/icon-settingprintnormal.png")
        },
        {
          name: "第三方配送",
          isActive: false,
          path: "/setting/delivery",
          icon:require("@/assets/img/menuIcons/icon-settingdelivery.png")
        },
        {
          name: "权限设置",
          isActive: false,
          path: "/setting/auth",
          icon:require("@/assets/img/menuIcons/icon-settingauth.png")
        },
        {
          name: "账号设置",
          isActive: false,
          path: "/setting/account",
          icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
        },
        {
          name: "打印机",
          isActive: false,
          path: "/setting/hardware",
          icon:require("@/assets/img/menuIcons/icon-settinghardware.png")
        },
        {
          name: "店铺服务",
          isActive: false,
          path: "/setting/shopService",
          icon:require("@/assets/img/menuIcons/icon-settingshopService.png")
        },
        {
          name: "配送设置",
          isActive: false,
          path: "/setting/freshDistribution/base",
          childrenPath: [
            "/setting/freshDistribution/base",
            "/setting/freshDistribution/time",
            "/setting/freshDistribution/pickUpPoint",
          ],
          icon:require("@/assets/img/menuIcons/icon-settingfreshDistributionbase.png")
        },
        {
          name: "企业介绍",
          isActive: false,
          path: "/setting/enterpriseProfile",
          icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
        },
      ];
      if (!isMaster) {
        topbarList = [
          {
            name: "店铺设置",
            isActive: false,
            path: "/setting",
            childrenPath: ["/setting/certification"],
            icon:require("@/assets/img/menuIcons/icon-setting.png")
          },
          {
            name: "小票设置",
            isActive: false,
            path: "/setting/print/normal",
            childrenPath: ["/setting/print/split", "/setting/print/template"],
            icon:require("@/assets/img/menuIcons/icon-settingprintnormal.png")
          },
          {
            name: "第三方配送",
            isActive: false,
            path: "/setting/delivery",
            icon:require("@/assets/img/menuIcons/icon-settingdelivery.png")
          },
          {
            name: "权限设置",
            isActive: false,
            path: "/setting/auth",
            icon:require("@/assets/img/menuIcons/icon-settingauth.png")
          },
          {
            name: "打印机",
            isActive: false,
            path: "/setting/hardware",
            icon:require("@/assets/img/menuIcons/icon-settinghardware.png")
          },
          {
            name: "店铺服务",
            isActive: false,
            path: "/setting/shopService",
            icon:require("@/assets/img/menuIcons/icon-settingshopService.png")
          },
          {
            name: "配送设置",
            isActive: false,
            path: "/setting/freshDistribution/base",
            childrenPath: [
              "/setting/freshDistribution/base",
              "/setting/freshDistribution/time",
              "/setting/freshDistribution/pickUpPoint",
            ],
            icon:require("@/assets/img/menuIcons/icon-settingfreshDistributionbase.png")
          },
          {
            name: "企业介绍",
            isActive: false,
            path: "/setting/enterpriseProfile",
            icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
          },
        ];
      }
      if (this.isDsType) {
        topbarList = [
          {
            name: "店铺设置",
            isActive: false,
            path: "/setting",
            childrenPath: ["/setting/certification"],
            icon:require("@/assets/img/menuIcons/icon-setting.png")
          },
          {
            name: "账号设置",
            isActive: false,
            path: "/setting/account",
            icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
          },
          {
            name: "运费服务",
            isActive: false,
            path: "/setting/freight",
            icon:require("@/assets/img/menuIcons/icon-settingfreight.png")
          },
          {
            name: "企业介绍",
            isActive: false,
            path: "/setting/enterpriseProfile",
            icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
          },
        ];
        if (!isMaster) {
          topbarList = [
            {
              name: "店铺设置",
              isActive: false,
              path: "/setting",
              childrenPath: ["/setting/certification"],
              icon:require("@/assets/img/menuIcons/icon-setting.png")
            },
            {
              name: "运费服务",
              isActive: false,
              path: "/setting/freight",
              icon:require("@/assets/img/menuIcons/icon-settingfreight.png")
            },
            {
              name: "企业介绍",
              isActive: false,
              path: "/setting/enterpriseProfile",
              icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
            },
          ];
        }
      }
      if (this.shopInfo.edcShopType == 5) {
        topbarList = [
          {
            name: "店铺设置",
            isActive: false,
            path: "/setting",
            childrenPath: ["/setting/certification"],
            icon:require("@/assets/img/menuIcons/icon-setting.png")
          },
          {
            name: "权限设置",
            isActive: false,
            path: "/setting/auth",
            icon:require("@/assets/img/menuIcons/icon-settingauth.png")
          },
          {
            name: "账号设置",
            isActive: false,
            path: "/setting/account",
            icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
          },
          {
            name: "企业介绍",
            isActive: false,
            path: "/setting/enterpriseProfile",
            icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
          },
        ];
        if (!isMaster) {
          topbarList = [
            {
              name: "店铺设置",
              isActive: false,
              path: "/setting",
              childrenPath: ["/setting/certification"],
              icon:require("@/assets/img/menuIcons/icon-setting.png")
            },
            {
              name: "权限设置",
              isActive: false,
              path: "/setting/auth",
              icon:require("@/assets/img/menuIcons/icon-settingauth.png")
            },
            {
              name: "账号设置",
              isActive: false,
              path: "/setting/account",
              icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
            },
            {
              name: "企业介绍",
              isActive: false,
              path: "/setting/enterpriseProfile",
              icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
            },
          ];
        }
      }
      if (this.shopInfo.edcShopType == 8) {
        topbarList = [
          {
            name: "店铺设置",
            isActive: false,
            path: "/settingDsShop",
            childrenPath: ["/setting/certification"],
            icon:require("@/assets/img/menuIcons/icon-setting.png")
          },
          {
            name: "密码设置",
            isActive: false,
            path: "/setting/account",
            icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
          },
          {
            name: "运费设置",
            isActive: false,
            path: "/setting/freight",
            icon:require("@/assets/img/menuIcons/icon-settingfreight.png")
          },
          {
            name: "企业介绍",
            isActive: false,
            path: "/setting/enterpriseProfile",
            icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
          },

          // {
          //   name: "打印设置",
          //   isActive: false,
          //   path: "/setting/print/normal",
          //   childrenPath: ["/setting/print/split", "/setting/print/template"],
          // },
        ];
        if (!isMaster) {
          topbarList = [
            {
              name: "店铺设置",
              isActive: false,
              path: "/settingDsShop",
              childrenPath: ["/setting/certification"],
              icon:require("@/assets/img/menuIcons/icon-setting.png")
            },
            {
              name: "密码设置",
              isActive: false,
              path: "/setting/account",
              icon:require("@/assets/img/menuIcons/icon-settingaccount.png")
            },
            {
              name: "运费设置",
              isActive: false,
              path: "/setting/freight",
              icon:require("@/assets/img/menuIcons/icon-settingfreight.png")
            },
            {
              name: "企业介绍",
              isActive: false,
              path: "/setting/enterpriseProfile",
              icon:require("@/assets/img/menuIcons/icon-settingenterpriseProfile.png")
            },
            // {
            //   name: "打印设置",
            //   isActive: false,
            //   path: "/setting/print/normal",
            //   childrenPath: ["/setting/print/split", "/setting/print/template"],
            // },
          ];
        }
      }
      if (this.isOwn) {
        topbarList.push({
          name: "共享WIFI",
          isActive: false,
          path: "/setting/wifiShare",
          icon:require("@/assets/img/menuIcons/icon-settingwifiShare.png")
        });
      }
      topbarList.push({
        name: "第三方平台",
        isActive: false,
        path: "/setting/thirdPlatform",
        icon:require("@/assets/img/menuIcons/icon-settingthirdPlatform.png")
      });
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
